module.exports = __webpack_public_path__ + "static/media/fb_ico.16b5e9b1.svg";